import React, { useState, useEffect } from 'react'
import useReactRouter from "use-react-router";
import moment from "moment";
import { useLazyQuery } from '@apollo/react-hooks'
import { DONATE_DATA } from "../../../apollo/donate"

import { Breadcrumb, Row, Form, Table, Image, Col } from 'react-bootstrap'
import Consts from "../../../consts"
import { Title } from "../../../common"
import { dateTimeLao, moneyCurrency } from "../../../helpers/Helper"


function DonateList() {
    const { history } = useReactRouter();
    const today = new Date();

    const [totalOf, setTotalOf] = useState(0)

    const [fillterName, setFillterName] = useState('')
    const [fillterStartDate, setFillterStartDate] = useState(moment(moment(today).add(-30, "days")).format('YYYY-MM-DD'))
    const [fillterEndDate, setFillterEndDate] = useState(moment(today).format('YYYY-MM-DD'))

    //function
    const [getDonate, { data }] = useLazyQuery(DONATE_DATA, {
        fetchPolicy: "network-only",
        variables: {
            where: {
                userName: fillterName === '' ? undefined : fillterName,
                startDate: fillterStartDate,
                endDate: fillterEndDate,
            }
        }
    });
    //function
    // ======>

    useEffect(() => {
        getDonate()
    }, [])

    useEffect(() => {
        if (data?.donates?.data) {
            let _tree=0
            for (let i = 0; i < data?.donates?.data?.length; i++){
                _tree += data?.donates?.data[i]?.amount
            }
            setTotalOf(_tree)
        }
    }, [data?.donates?.data])


    return (
        <div>
            <Breadcrumb style={{ marginTop: 60, fontSize: '12px' }}>
                <Breadcrumb.Item active>Donation</Breadcrumb.Item>
            </Breadcrumb>
            <div style={Consts.MAIN_CARD} >
                <Title text='Donation' />

                <Row className="mt-2">
                    <Col md={6}>
                        <Form.Group >
                            <Form.Control size='lg' type="text" style={{ marginTop: 30,height:36,fontSize:16 }} placeholder="Searching by name..." onChange={(e) => setFillterName(e?.target?.value)}/>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group >
                            <Form.Label>From date</Form.Label>
                            <Form.Control size='lg' type="date" defaultValue={fillterStartDate} onChange={(e) => setFillterStartDate(e?.target?.value)}/>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group >
                            <Form.Label>To date</Form.Label>
                            <Form.Control size='lg' type="date" defaultValue={fillterEndDate} onChange={(e) => setFillterEndDate(e?.target?.value)}/>
                        </Form.Group>
                    </Col>
                </Row>



                <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20, marginBottom: 20 }}>
                    <h4>Show {data?.donates?.data?.length} List</h4>
                </div>



                <Table striped>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name and surname</th>
                            <th>Phone number</th>
                            <th>Email</th>
                            <th>Amount</th>
                            <th>Donated date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.donates?.data?.map((item, index) =>
                            <tr key={index}
                                onClick={() => history.push(Consts.PAGE_DONATE_DETAIL, item)}
                            >
                                <td>{index + 1}</td>
                                <td>
                                    <Image src={item?.userId?.image ? Consts.URL_FOR_SHOW_PHOTO + item?.userId?.image : "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Circle-icons-profile.svg/1024px-Circle-icons-profile.svg.png"}
                                        style={{ width: 40, height: 40 }}
                                    />
                                    &nbsp;&nbsp;&nbsp;

                                    {item?.userName}
                                </td>
                                <td>{item?.phone ?? "-"}</td>
                                <td>{item?.email ?? "-"}</td>
                                <td>{moneyCurrency(item?.amount) ?? 0}</td>
                                <td>{dateTimeLao(item?.createdAt)}</td>
                            </tr>
                        )}

                            <tr>
                                <th colSpan='4' style={{textAlign:'center'}}>Total</th>
                                <th>{moneyCurrency(totalOf) ?? "0"} </th>
                                <th></th>
                            </tr>

                    </tbody>
                </Table>


            </div>



        </div>
    )
}
export default DonateList